import { Navigate, useLocation } from "react-router-dom";
import { toast } from "react-toastify";

function RequireAuth({ children }) {
    let location = useLocation()
    const token = localStorage.getItem("token")
    const user = JSON.parse(localStorage.getItem("user"))

    if (!token) {
        return <Navigate to="/signin" state={{ from: location }} replace />
    } else if (user?.userType !== "admin" && user?.userType !== "superAdmin") {
        toast.warn("You don't have access to this resource", {
            position: toast.POSITION.TOP_RIGHT
        })
        return <Navigate to='/' />
    }

    return children
}

export default RequireAuth